import { render } from "./SuperUserDetails.vue?vue&type=template&id=e392f92e&scoped=true&ts=true"
import script from "./SuperUserDetails.vue?vue&type=script&lang=ts"
export * from "./SuperUserDetails.vue?vue&type=script&lang=ts"

import "./SuperUserDetails.vue?vue&type=style&index=0&id=e392f92e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e392f92e"]])

export default __exports__